export default function getPackageJsonSchema(context: { projectRoot: string }) {
  return {
    type: 'object',
    required: [
      'author',
      'dependencies',
      'devDependencies',
      'homepage',
      'name',
      'version',
    ],
    properties: {
      author: {
        npmAuthor: {},
      },
      dependencies: {
        type: 'object',
        required: ['@todesktop/runtime'],
        // custom keyword that checks package names aren't included in dependencies
        excludedDependencies: {
          dependencyKey: 'dependencies',
          blacklist: ['@todesktop/cli'],
        },
        properties: {
          '@todesktop/runtime': {
            type: 'string',
          },
        },
      },
      devDependencies: {
        type: 'object',
        required: ['electron'],
        properties: {
          electron: {
            oneOf: [
              {
                type: 'string',
                semanticVersion: {
                  packageName: 'electron',
                  mustBeExact: true,
                },
              },
              {
                type: 'string',
                pattern: '^catalog:',
              },
            ],
          },
        },
      },
      name: {
        type: 'string',
        minLength: 1,
      },
      scripts: {
        type: 'object',
        properties: {
          'todesktop:beforeInstall': {
            type: 'string',
            file: {
              from: context.projectRoot,
              mustBeFile: true,
            },
          },
          'todesktop:beforeBuild': {
            type: 'string',
            file: {
              from: context.projectRoot,
              mustBeFile: true,
            },
          },
          'todesktop:afterPack': {
            type: 'string',
            file: {
              from: context.projectRoot,
              mustBeFile: true,
            },
          },
        },
      },
      version: {
        type: 'string',
        semanticVersion: {},
      },
    },
  };
}
